import { compose, values, map, prop, flatten, indexBy } from 'ramda';

const Plan = ({ sku, title, hashes, price }) => ({
  sku,
  title,
  hashes,
  price: {
    amount: price.amount,
    savings: price.savings,
    monthlyCost: price.monthly_cost,
    currencyCode: price.currency_code,
  },
});

const flattenPlans = compose(flatten, map(prop('plans')), values);

const Plans = compose(indexBy(prop('sku')), map(Plan), flattenPlans);

export { Plans };
